module.exports = __webpack_public_path__ + "static/0042-c91b1e7c14a88cf31656e189d38c34f0.png";